import BoneWebUIAll from "@bone/bone-web-ui";
import BoneWebUIDPL from "@bone/bone-web-ui-dpl";
import mod0 from "@bone/bone-web-ui/lib/accordion";
import mod1 from "@bone/bone-web-ui/lib/affix";
import mod2 from "@bone/bone-web-ui/lib/animate";
import mod3 from "@bone/bone-web-ui/lib/badge";
import mod4 from "@bone/bone-web-ui/lib/balloon";
import mod5 from "@bone/bone-web-ui/lib/breadcrumb";
import mod6 from "@bone/bone-web-ui/lib/button";
import mod7 from "@bone/bone-web-ui/lib/calendar";
import mod8 from "@bone/bone-web-ui/lib/card";
import mod9 from "@bone/bone-web-ui/lib/cascader-select";
import mod10 from "@bone/bone-web-ui/lib/cascader";
import mod11 from "@bone/bone-web-ui/lib/checkbox";
import mod12 from "@bone/bone-web-ui/lib/config-provider";
import mod13 from "@bone/bone-web-ui/lib/date-picker";
import mod14 from "@bone/bone-web-ui/lib/dialog";
import mod15 from "@bone/bone-web-ui/lib/dom";
import mod16 from "@bone/bone-web-ui/lib/dropdown";
import mod17 from "@bone/bone-web-ui/lib/feedback";
import mod18 from "@bone/bone-web-ui/lib/field";
import mod19 from "@bone/bone-web-ui/lib/form";
import mod20 from "@bone/bone-web-ui/lib/grid";
import mod21 from "@bone/bone-web-ui/lib/icon";
import mod22 from "@bone/bone-web-ui/lib/input";
import mod23 from "@bone/bone-web-ui/lib/loading";
import mod24 from "@bone/bone-web-ui/lib/locale-provider";
import mod25 from "@bone/bone-web-ui/lib/menu";
import mod26 from "@bone/bone-web-ui/lib/moment";
import mod27 from "@bone/bone-web-ui/lib/nav";
import mod28 from "@bone/bone-web-ui/lib/navigation";
import mod29 from "@bone/bone-web-ui/lib/notice";
import mod30 from "@bone/bone-web-ui/lib/number-picker";
import mod31 from "@bone/bone-web-ui/lib/overlay";
import mod32 from "@bone/bone-web-ui/lib/pagination";
import mod33 from "@bone/bone-web-ui/lib/progress";
import mod34 from "@bone/bone-web-ui/lib/radio";
import mod35 from "@bone/bone-web-ui/lib/range";
import mod36 from "@bone/bone-web-ui/lib/rating";
import mod37 from "@bone/bone-web-ui/lib/search";
import mod38 from "@bone/bone-web-ui/lib/select";
import mod39 from "@bone/bone-web-ui/lib/slider";
import mod40 from "@bone/bone-web-ui/lib/step";
import mod41 from "@bone/bone-web-ui/lib/switch";
import mod42 from "@bone/bone-web-ui/lib/tab";
import mod43 from "@bone/bone-web-ui/lib/table";
import mod44 from "@bone/bone-web-ui/lib/tag";
import mod45 from "@bone/bone-web-ui/lib/time-picker";
import mod46 from "@bone/bone-web-ui/lib/timeline";
import mod47 from "@bone/bone-web-ui/lib/transfer";
import mod48 from "@bone/bone-web-ui/lib/tree-select";
import mod49 from "@bone/bone-web-ui/lib/tree";
import mod50 from "@bone/bone-web-ui/lib/upload";

const BoneWebUI = {
    "*": BoneWebUIAll,
    "accordion": mod0,
    "affix": mod1,
    "animate": mod2,
    "badge": mod3,
    "balloon": mod4,
    "breadcrumb": mod5,
    "button": mod6,
    "calendar": mod7,
    "card": mod8,
    "cascader-select": mod9,
    "cascader": mod10,
    "checkbox": mod11,
    "config-provider": mod12,
    "date-picker": mod13,
    "dialog": mod14,
    "dom": mod15,
    "dropdown": mod16,
    "feedback": mod17,
    "field": mod18,
    "form": mod19,
    "grid": mod20,
    "icon": mod21,
    "input": mod22,
    "loading": mod23,
    "locale-provider": mod24,
    "menu": mod25,
    "moment": mod26,
    "nav": mod27,
    "navigation": mod28,
    "notice": mod29,
    "number-picker": mod30,
    "overlay": mod31,
    "pagination": mod32,
    "progress": mod33,
    "radio": mod34,
    "range": mod35,
    "rating": mod36,
    "search": mod37,
    "select": mod38,
    "slider": mod39,
    "step": mod40,
    "switch": mod41,
    "tab": mod42,
    "table": mod43,
    "tag": mod44,
    "time-picker": mod45,
    "timeline": mod46,
    "transfer": mod47,
    "tree-select": mod48,
    "tree": mod49,
    "upload": mod50
};

export {
    BoneWebUI,
    BoneWebUIDPL
}

export default {
    "@bone/bone-web-ui": BoneWebUI["*"],
    "@bone/bone-web-ui-dpl": BoneWebUIDPL,
    "@bone/bone-web-ui/lib/accordion": BoneWebUI["accordion"],
    "@bone/bone-web-ui/lib/affix": BoneWebUI["affix"],
    "@bone/bone-web-ui/lib/animate": BoneWebUI["animate"],
    "@bone/bone-web-ui/lib/badge": BoneWebUI["badge"],
    "@bone/bone-web-ui/lib/balloon": BoneWebUI["balloon"],
    "@bone/bone-web-ui/lib/breadcrumb": BoneWebUI["breadcrumb"],
    "@bone/bone-web-ui/lib/button": BoneWebUI["button"],
    "@bone/bone-web-ui/lib/calendar": BoneWebUI["calendar"],
    "@bone/bone-web-ui/lib/card": BoneWebUI["card"],
    "@bone/bone-web-ui/lib/cascader-select": BoneWebUI["cascader-select"],
    "@bone/bone-web-ui/lib/cascader": BoneWebUI["cascader"],
    "@bone/bone-web-ui/lib/checkbox": BoneWebUI["checkbox"],
    "@bone/bone-web-ui/lib/config-provider": BoneWebUI["config-provider"],
    "@bone/bone-web-ui/lib/date-picker": BoneWebUI["date-picker"],
    "@bone/bone-web-ui/lib/dialog": BoneWebUI["dialog"],
    "@bone/bone-web-ui/lib/dom": BoneWebUI["dom"],
    "@bone/bone-web-ui/lib/dropdown": BoneWebUI["dropdown"],
    "@bone/bone-web-ui/lib/feedback": BoneWebUI["feedback"],
    "@bone/bone-web-ui/lib/field": BoneWebUI["field"],
    "@bone/bone-web-ui/lib/form": BoneWebUI["form"],
    "@bone/bone-web-ui/lib/grid": BoneWebUI["grid"],
    "@bone/bone-web-ui/lib/icon": BoneWebUI["icon"],
    "@bone/bone-web-ui/lib/input": BoneWebUI["input"],
    "@bone/bone-web-ui/lib/loading": BoneWebUI["loading"],
    "@bone/bone-web-ui/lib/locale-provider": BoneWebUI["locale-provider"],
    "@bone/bone-web-ui/lib/menu": BoneWebUI["menu"],
    "@bone/bone-web-ui/lib/moment": BoneWebUI["moment"],
    "@bone/bone-web-ui/lib/nav": BoneWebUI["nav"],
    "@bone/bone-web-ui/lib/navigation": BoneWebUI["navigation"],
    "@bone/bone-web-ui/lib/notice": BoneWebUI["notice"],
    "@bone/bone-web-ui/lib/number-picker": BoneWebUI["number-picker"],
    "@bone/bone-web-ui/lib/overlay": BoneWebUI["overlay"],
    "@bone/bone-web-ui/lib/pagination": BoneWebUI["pagination"],
    "@bone/bone-web-ui/lib/progress": BoneWebUI["progress"],
    "@bone/bone-web-ui/lib/radio": BoneWebUI["radio"],
    "@bone/bone-web-ui/lib/range": BoneWebUI["range"],
    "@bone/bone-web-ui/lib/rating": BoneWebUI["rating"],
    "@bone/bone-web-ui/lib/search": BoneWebUI["search"],
    "@bone/bone-web-ui/lib/select": BoneWebUI["select"],
    "@bone/bone-web-ui/lib/slider": BoneWebUI["slider"],
    "@bone/bone-web-ui/lib/step": BoneWebUI["step"],
    "@bone/bone-web-ui/lib/switch": BoneWebUI["switch"],
    "@bone/bone-web-ui/lib/tab": BoneWebUI["tab"],
    "@bone/bone-web-ui/lib/table": BoneWebUI["table"],
    "@bone/bone-web-ui/lib/tag": BoneWebUI["tag"],
    "@bone/bone-web-ui/lib/time-picker": BoneWebUI["time-picker"],
    "@bone/bone-web-ui/lib/timeline": BoneWebUI["timeline"],
    "@bone/bone-web-ui/lib/transfer": BoneWebUI["transfer"],
    "@bone/bone-web-ui/lib/tree-select": BoneWebUI["tree-select"],
    "@bone/bone-web-ui/lib/tree": BoneWebUI["tree"],
    "@bone/bone-web-ui/lib/upload": BoneWebUI["upload"]
}


// WEBPACK FOOTER //
// ./packages/bone-web-ui@1/index.js